module.exports = __webpack_public_path__ + "static/img/15bg_5.9b9ff42.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/15bg_5.png
// module id = 654
// module chunks = 1